/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Verpackung } from '../models';
/**
 * VerpackungService - axios parameter creator
 * @export
 */
export const VerpackungServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Verpackung
         * @summary Verpackungen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerpackungById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVerpackungById', 'id', id)
            const localVarPath = `/api/verpackungen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Verpackungen
         * @summary Verpackungen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerpackungen: async (mandant?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/verpackungen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Verpackungen, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
         * @summary Verpackungen
         * @param {string} searchParam 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerpackungenAutoCompleteMatches: async (searchParam: string, maxResults?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchParam' is not null or undefined
            assertParamExists('getVerpackungenAutoCompleteMatches', 'searchParam', searchParam)
            const localVarPath = `/api/verpackungen/autoCompleteMatches/{searchParam}`
                .replace(`{${"searchParam"}}`, encodeURIComponent(String(searchParam)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Verpackungen für einen Mandanten die nur GGVS Verpackungen sind oder kein GGVS
         * @summary Verpackungen
         * @param {number} [mandant] mandant
         * @param {boolean} [isGGVS] isGGVS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerpackungenOnlyGGVSOrWithout: async (mandant?: number, isGGVS?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/verpackungen/ggvs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }

            if (isGGVS !== undefined) {
                localVarQueryParameter['isGGVS'] = isGGVS;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Verpackungen anhand der Suchkriterien
         * @summary Verpackungensuche
         * @param {string} [verpackungsName] Verpackungsname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVerpackungen: async (verpackungsName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/verpackungen/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (verpackungsName !== undefined) {
                localVarQueryParameter['verpackungsName'] = verpackungsName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Verpackungen anhand der Suchkriterien
         * @summary Verpackungensuche
         * @param {string} [verpackungsName] Verpackungsname
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVerpackungenByMandant: async (verpackungsName?: string, body?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/verpackungen/searchByMandant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (verpackungsName !== undefined) {
                localVarQueryParameter['verpackungsName'] = verpackungsName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VerpackungService - functional programming interface
 * @export
 */
export const VerpackungServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VerpackungServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Verpackung
         * @summary Verpackungen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVerpackungById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Verpackung>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVerpackungById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Verpackungen
         * @summary Verpackungen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVerpackungen(mandant?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Verpackung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVerpackungen(mandant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Verpackungen, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
         * @summary Verpackungen
         * @param {string} searchParam 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVerpackungenAutoCompleteMatches(searchParam: string, maxResults?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Verpackung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVerpackungenAutoCompleteMatches(searchParam, maxResults, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Verpackungen für einen Mandanten die nur GGVS Verpackungen sind oder kein GGVS
         * @summary Verpackungen
         * @param {number} [mandant] mandant
         * @param {boolean} [isGGVS] isGGVS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVerpackungenOnlyGGVSOrWithout(mandant?: number, isGGVS?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Verpackung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVerpackungenOnlyGGVSOrWithout(mandant, isGGVS, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Verpackungen anhand der Suchkriterien
         * @summary Verpackungensuche
         * @param {string} [verpackungsName] Verpackungsname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchVerpackungen(verpackungsName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Verpackung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchVerpackungen(verpackungsName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Verpackungen anhand der Suchkriterien
         * @summary Verpackungensuche
         * @param {string} [verpackungsName] Verpackungsname
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchVerpackungenByMandant(verpackungsName?: string, body?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Verpackung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchVerpackungenByMandant(verpackungsName, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VerpackungService - factory interface
 * @export
 */
export const VerpackungServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VerpackungServiceFp(configuration)
    return {
        /**
         * Liefert eine Verpackung
         * @summary Verpackungen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerpackungById(id: number, options?: any): AxiosPromise<Verpackung> {
            return localVarFp.getVerpackungById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Verpackungen
         * @summary Verpackungen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerpackungen(mandant?: number, options?: any): AxiosPromise<Array<Verpackung>> {
            return localVarFp.getVerpackungen(mandant, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Verpackungen, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
         * @summary Verpackungen
         * @param {string} searchParam 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerpackungenAutoCompleteMatches(searchParam: string, maxResults?: number, options?: any): AxiosPromise<Array<Verpackung>> {
            return localVarFp.getVerpackungenAutoCompleteMatches(searchParam, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Verpackungen für einen Mandanten die nur GGVS Verpackungen sind oder kein GGVS
         * @summary Verpackungen
         * @param {number} [mandant] mandant
         * @param {boolean} [isGGVS] isGGVS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerpackungenOnlyGGVSOrWithout(mandant?: number, isGGVS?: boolean, options?: any): AxiosPromise<Array<Verpackung>> {
            return localVarFp.getVerpackungenOnlyGGVSOrWithout(mandant, isGGVS, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Verpackungen anhand der Suchkriterien
         * @summary Verpackungensuche
         * @param {string} [verpackungsName] Verpackungsname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVerpackungen(verpackungsName?: string, options?: any): AxiosPromise<Array<Verpackung>> {
            return localVarFp.searchVerpackungen(verpackungsName, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Verpackungen anhand der Suchkriterien
         * @summary Verpackungensuche
         * @param {string} [verpackungsName] Verpackungsname
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVerpackungenByMandant(verpackungsName?: string, body?: number, options?: any): AxiosPromise<Array<Verpackung>> {
            return localVarFp.searchVerpackungenByMandant(verpackungsName, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VerpackungService - interface
 * @export
 * @interface VerpackungService
 */
export interface VerpackungServiceInterface {
    /**
     * Liefert eine Verpackung
     * @summary Verpackungen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungServiceInterface
     */
    getVerpackungById(id: number, options?: any): AxiosPromise<Verpackung>;

    /**
     * Liefert eine Liste von Verpackungen
     * @summary Verpackungen
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungServiceInterface
     */
    getVerpackungen(mandant?: number, options?: any): AxiosPromise<Array<Verpackung>>;

    /**
     * Liefert eine Liste von Verpackungen, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
     * @summary Verpackungen
     * @param {string} searchParam 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungServiceInterface
     */
    getVerpackungenAutoCompleteMatches(searchParam: string, maxResults?: number, options?: any): AxiosPromise<Array<Verpackung>>;

    /**
     * Liefert alle Verpackungen für einen Mandanten die nur GGVS Verpackungen sind oder kein GGVS
     * @summary Verpackungen
     * @param {number} [mandant] mandant
     * @param {boolean} [isGGVS] isGGVS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungServiceInterface
     */
    getVerpackungenOnlyGGVSOrWithout(mandant?: number, isGGVS?: boolean, options?: any): AxiosPromise<Array<Verpackung>>;

    /**
     * Liefert eine Liste von Verpackungen anhand der Suchkriterien
     * @summary Verpackungensuche
     * @param {string} [verpackungsName] Verpackungsname
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungServiceInterface
     */
    searchVerpackungen(verpackungsName?: string, options?: any): AxiosPromise<Array<Verpackung>>;

    /**
     * Liefert eine Liste von Verpackungen anhand der Suchkriterien
     * @summary Verpackungensuche
     * @param {string} [verpackungsName] Verpackungsname
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungServiceInterface
     */
    searchVerpackungenByMandant(verpackungsName?: string, body?: number, options?: any): AxiosPromise<Array<Verpackung>>;

}

/**
 * VerpackungService - object-oriented interface
 * @export
 * @class VerpackungService
 * @extends {BaseAPI}
 */
export class VerpackungService extends BaseAPI implements VerpackungServiceInterface {
    /**
     * Liefert eine Verpackung
     * @summary Verpackungen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungService
     */
    public getVerpackungById(id: number, options?: any) {
        return VerpackungServiceFp(this.configuration).getVerpackungById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Verpackungen
     * @summary Verpackungen
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungService
     */
    public getVerpackungen(mandant?: number, options?: any) {
        return VerpackungServiceFp(this.configuration).getVerpackungen(mandant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Verpackungen, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
     * @summary Verpackungen
     * @param {string} searchParam 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungService
     */
    public getVerpackungenAutoCompleteMatches(searchParam: string, maxResults?: number, options?: any) {
        return VerpackungServiceFp(this.configuration).getVerpackungenAutoCompleteMatches(searchParam, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Verpackungen für einen Mandanten die nur GGVS Verpackungen sind oder kein GGVS
     * @summary Verpackungen
     * @param {number} [mandant] mandant
     * @param {boolean} [isGGVS] isGGVS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungService
     */
    public getVerpackungenOnlyGGVSOrWithout(mandant?: number, isGGVS?: boolean, options?: any) {
        return VerpackungServiceFp(this.configuration).getVerpackungenOnlyGGVSOrWithout(mandant, isGGVS, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Verpackungen anhand der Suchkriterien
     * @summary Verpackungensuche
     * @param {string} [verpackungsName] Verpackungsname
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungService
     */
    public searchVerpackungen(verpackungsName?: string, options?: any) {
        return VerpackungServiceFp(this.configuration).searchVerpackungen(verpackungsName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Verpackungen anhand der Suchkriterien
     * @summary Verpackungensuche
     * @param {string} [verpackungsName] Verpackungsname
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerpackungService
     */
    public searchVerpackungenByMandant(verpackungsName?: string, body?: number, options?: any) {
        return VerpackungServiceFp(this.configuration).searchVerpackungenByMandant(verpackungsName, body, options).then((request) => request(this.axios, this.basePath));
    }
}
